import cx from 'clsx';

import PointOnly12Icon from '~/assets/icons/point_only_12x12.svg';

type Props = {
  className?: string;
};
export function PointOnlyBadge({ className }: Props) {
  return (
    <div
      className={cx(
        cx(
          'flex items-center gap-4 text-blue-600 typo-footnote300-semibold',
          className,
        ),
      )}
    >
      <PointOnly12Icon />
      포인트 전용 상품
    </div>
  );
}
